export const setTasksList = (state, data) => {
    state.tasksList = data;
};
export const setTasksStatus = (state, data) => {
    state.tasksStatus = data;
};
export const setTasksOverview = (state, data) => {
    state.tasksOverview = data;
};

export const setTaskForTeam = (state, data) => {
    state.taskForTeam = data;
};

export const setActive = (state, data) => {
    state.active = data;
};

export const setRemoveRouteQuery = (state, data) => {
    state.removeRouteQuery = data;
};
